<template>
  <div class="spinner w-30 text-center">
    <div
      class="bounce1 w-10 h-10"
      :style="{ backgroundColor: backgroundColorForLoader }"
    />
    <div
      class="bounce2 w-10 h-10"
      :style="{ backgroundColor: backgroundColorForLoader }"
    />
    <div
      class="bounce3 w-10 h-10"
      :style="{ backgroundColor: backgroundColorForLoader }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { DEFAULT_COLOR_FOR_LOADER } from '@/constants';

export default defineComponent({
  name: 'Loading',
  computed: {
    ...mapGetters([
      'global'
    ]),
    backgroundColorForLoader (): string {
      return this.global.primaryColor || DEFAULT_COLOR_FOR_LOADER;
    }
  }
});
</script>

<style>
.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.spinner > div {
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
